export default __webpack_public_path__ + "tmp_src/components/CollectionSlider/CollectionSlider.css.liquid";